import { usePathname } from "next/navigation";

export function useActiveNavigation() {
  const pathname = usePathname();

  const isActive = (href: string): boolean => {
    // Handle exact path matches
    if (href === pathname) {
      return true;
    }
    
    // Handle sub-paths (e.g., /about-us/ matches /about-us)
    if (pathname.startsWith(href) && href !== '/') {
      return true;
    }
    
    return false;
  };

  const getActiveClasses = (href: string, baseClasses: string = ""): string => {
    const activeClasses = "underline decoration-2 underline-offset-4";
    return isActive(href) 
      ? `${baseClasses} ${activeClasses}`.trim()
      : baseClasses;
  };

  return {
    isActive,
    getActiveClasses,
    pathname,
  };
}
